export enum ApiClientType {
  Pricing = 'PRICING',
  Trading = 'TRADING',
}

export interface IApiClient {
  enabled: boolean;
  id: string;
  name: string;
  type: ApiClientType;
}
